<ms-event-pick
    class="grid-option-selectable"
    [class.offline]="!option.online || showSuspendedSelection"
    [class.highlight]="isHighlighted"
    [option]="option"
    [event]="event"
    [optionGroup]="optionGroup"
    [trackingSource]="tracking.source"
    [trackingGameDetails]="tracking.gameDetails"
    [trackingModuleType]="tracking.moduleType"
    [sourceOfPick]="sourceOfPick"
    [betDetails]="betDetails"
    [trackingPosition]="tracking.position"
    [calenderTrack]="tracking.calendarTitle">
    @if (offline) {
        @if (!isEpcotEnabled) {
            <vn-icon name="theme-locked-i" size="13" />
        } @else {
            <vn-icon name="theme-locked" size="16" />
        }
    } @else {
        <div class="option-name">
            @if (showOptionname || showCenterOptionName) {
                <div [class.option-name-value]="showOptionname" [class.no-goal]="showCenterOptionName">{{ option.name }}</div>
            }
            @if (showAttributeValue && attributeValue) {
                <div
                    class="option-attribute"
                    [class.small-font]="attributeValue.length > 6"
                    [class.option-group-attribute]="optionGroup.categoryAttribute">
                    {{ attributeValue }}
                </div>
            }
        </div>
        <div class="option option-value">
            <ng-content />
            <ms-font-resizer [defaultSize]="1" [maxChars]="6" [shouldGetExtSettings]="true" [value]="option.nativePrice | msNativePriceFormatter" />
        </div>
    }
</ms-event-pick>
